import { defineComponent as r, toRef as l, computed as s, h as d, Teleport as i } from "vue";
import { getSlot as o } from "./ghl-ui.es735.js";
import n from "./ghl-ui.es679.js";
const h = r({
  name: "LazyTeleport",
  props: {
    to: {
      type: [String, Object],
      default: void 0
    },
    disabled: Boolean,
    show: {
      type: Boolean,
      required: !0
    }
  },
  setup(t) {
    return {
      showTeleport: n(l(t, "show")),
      mergedTo: s(() => {
        const { to: e } = t;
        return e ?? "body";
      })
    };
  },
  render() {
    return this.showTeleport ? this.disabled ? o("lazy-teleport", this.$slots) : d(i, {
      disabled: this.disabled,
      to: this.mergedTo
    }, o("lazy-teleport", this.$slots)) : null;
  }
});
export {
  h as default
};
